import { render, staticRenderFns } from "./admin-application-paid-show.vue?vue&type=template&id=4b6f81cd&scoped=true"
import script from "./admin-application-paid-show.vue?vue&type=script&lang=js"
export * from "./admin-application-paid-show.vue?vue&type=script&lang=js"
import style0 from "./admin-application-paid-show.vue?vue&type=style&index=0&id=4b6f81cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6f81cd",
  null
  
)

export default component.exports